import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";

import { Utils } from "app/models/general/utils";

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private router: Router) {}

  canActivate() {
    if (!Utils.getToken()) {
      this.router.navigate(["/pages/login"]);
      return false;
    }
    return true;
  }
}
